var mp = mp || {};

// Data Tables
//-----------------------------------------------------------------
mp.dataTabels = function() {

    var $containter = $('#dataTables');
    if (!$containter.length) {
        return;
    }

    $.extend( $.fn.dataTable.defaults, {
    	responsive: true,
    	lengthChange: false,
        pageLength: 20,
        ordering: false,
    });

    $containter.DataTable({
        
    });

};


// Set Datepicker
//-----------------------------------------------------------------
mp.datePicker = function() {
    var $element = $('.js_datePicker');
    if (!$element.length) {
        return;
    }

    $element.datepicker({
        'format': 'dd.mm.yyyy.',
        'autoclose': true,
        'language': 'hr',
        'orientation': 'bottom',
        'weekStart': '1',
        'daysOfWeekHighlighted': '0,6'
    });
};


// Time Range Selector
//-----------------------------------------------------------------
mp.timePicker = function() {

    var $containter = $('.js_timePicker');
    if (!$containter.length) {
        return;
    }

    var $time = $containter.find(".time");
    var $time_start = $containter.find(".time.start");
    var $time_end = $containter.find(".time.end");

    $time.timepicker({
        'forceRoundTime' : true,
        'show2400' : true,
        'timeFormat': 'H:i',
        'step' : '15',
        'stopScrollPropagation' : true,
    });

    $time_start.timepicker('option', {
        'minTime' : '08:00',
        'maxTime' : '21:45',
    });

    $time_end.timepicker('option', {
        'minTime' : '08:15',
        'maxTime' : '22:00',
    });

    $containter.datepair({
        'defaultTimeDelta' : 900000,
    });
};


// Alert Pop
//-----------------------------------------------------------------
mp.alertPop = function() {
    var $element = $('.alert-pop');
    if (!$element.length) {
        return;
    }

    $element.on("click",function(e){
        $msg = "Da li ste sigurni?";

        $content = $(this).data("alert");
        if (typeof($content) != "undefined" && $content !== null) {
            $msg = $content;
        }

        $pop = confirm($msg);
        if ($pop != true) {
            e.preventDefault();
            return false;
        }
    });
};



// Set Availability Date
//-----------------------------------------------------------------
mp.setAvailabilityDate = function() {
    var $element = $('.js_addAvailability');
    if (!$element.length) {
        return;
    }

    var $form = $('#availability-form');

    $element.on('click', function(){
        $date = $(this).data('date');
        $form.find('#value-date').val($date);
        $form.find('#selected-date').html($date);
    })
};





$(document).ready(function (){
    mp.dataTabels();
    mp.datePicker();
    mp.timePicker();
    mp.alertPop();
    mp.setAvailabilityDate();
});